module.exports = __webpack_public_path__ + "img/thre_schema.d049c990.png";